import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ProjectApiModel } from '@/core/models/api/project-api-model.model';

export const selectProjectId = (a: ProjectApiModel): number => {
    if (!a.projectId) {
        throw new Error('projectId is required');
    }
    return a.projectId;
};

export interface ProjectState extends EntityState<ProjectApiModel> {
    selectedProject: ProjectApiModel | null;
    // currentTender: Current
    loading: boolean;
    errorMessage: string | null;
}

export const projectAdapter: EntityAdapter<ProjectApiModel> = createEntityAdapter<ProjectApiModel>({
    selectId: selectProjectId,
    sortComparer: false
});

export const initialProjectState: ProjectState = projectAdapter.getInitialState({
    selectedProject: null,
    loading: false,
    errorMessage: null
});
